(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventDialogController', EventDialogController);

    EventDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Event', 'EventStatus', 'Employee', 'EventCategoryType', 'EventCustomerSector', 'EventSchedule'];

    function EventDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Event, EventStatus, Employee, EventCategoryType, EventCustomerSector, EventSchedule) {
        var vm = this;
        vm.event = entity;
        vm.eventstatuses = EventStatus.query();
        vm.employees = Employee.query();
        vm.eventcategorytypes = EventCategoryType.query();
        vm.eventcustomersectors = EventCustomerSector.query();
        vm.eventschedules = EventSchedule.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:eventUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.event.id !== null) {
                Event.update(vm.event, onSaveSuccess, onSaveError);
            } else {
                Event.save(vm.event, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startedAt = false;
        vm.datePickerOpenStatus.finishedAt = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
